import React, { useState } from "react";
import { fileUrl , formatTanggal, hitungUsia} from "@/lib/api";
import { X, IdCard } from "lucide-react";
import KartuPelajarModal from "@/components/KartuPelajarModal";
import { SiswaEkskulSection } from "@/components/SiswaEkskulSection";

export function SiswaDetailModal({ detail, onClose }) {
  const [showKartu, setShowKartu] = useState(false);
  if (!detail) return null;
  const usia = detail.usia ?? hitungUsia(detail.tanggal_lahir);
  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl max-w-2xl w-full p-6 max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()} data-testid="siswa-detail-modal">
        <div className="flex items-center justify-between mb-5">
          <h3 className="text-xl font-bold text-slate-900">Detail Siswa</h3>
          <button onClick={onClose}><X className="w-5 h-5 text-slate-400" /></button>
        </div>
        <div className="flex gap-5 mb-5">
          {detail.foto_file_id ? (
            <img src={fileUrl(detail.foto_file_id)} alt="Foto" className="w-28 h-28 rounded-xl object-cover border border-slate-200" />
          ) : (
            <div className="w-28 h-28 rounded-xl bg-slate-100 flex items-center justify-center text-slate-300 text-4xl font-bold">{detail.nama[0]}</div>
          )}
          <div>
            <div className="text-2xl font-bold text-slate-900">{detail.nama}</div>
            <div className="font-mono text-sm text-slate-500">NISN: {detail.nis}</div>
            <div className="mt-2 flex items-center gap-2 flex-wrap">
              <span className={detail.status === "aktif" ? "pp-badge-success" : "pp-badge-danger"}>{detail.status}</span>
              <button onClick={() => setShowKartu(true)} className="pp-btn-primary text-xs" data-testid="kepsek-open-kartu">
                <IdCard className="w-3.5 h-3.5" /> Kartu Pelajar
              </button>
            </div>
          </div>
        </div>
        <dl className="grid sm:grid-cols-2 gap-x-6 gap-y-3 text-sm">
          {[
            ["Tempat/Tgl Lahir", `${detail.tempat_lahir || "—"}, ${formatTanggal(detail.tanggal_lahir)}`],
            ["Usia", usia == null ? "—" : `${usia} tahun`],
            ["Jenis Kelamin", detail.jenis_kelamin === "L" ? "Laki-laki" : "Perempuan"],
            ["Alamat", detail.alamat || "—"],
            ["Ketunaan", detail.ketunaan || "—"],
            ["Nama Ayah", detail.nama_ayah || "—"],
            ["Pekerjaan Ayah", detail.pekerjaan_ayah || "—"],
            ["No. Telp Ayah", detail.telp_ayah || "—"],
            ["Nama Ibu", detail.nama_ibu || "—"],
            ["Pekerjaan Ibu", detail.pekerjaan_ibu || "—"],
            ["No. Telp Ibu", detail.telp_ibu || "—"],
            ["Email Orang Tua", detail.email_orangtua || "—"],
          ].map(([k, v]) => (
            <div key={k}><dt className="text-xs uppercase text-slate-500">{k}</dt><dd className="text-slate-900 mt-0.5">{v}</dd></div>
          ))}
        </dl>
        <SiswaEkskulSection siswaId={detail.id} />
      </div>
      {showKartu && <KartuPelajarModal siswa={detail} onClose={() => setShowKartu(false)} />}
    </div>
  );
}
